export const attributes = {
    length: 
    {
        name: "LENGTH",
        values: {
            "Less than 10 miles": "<10",
            "10 - 20 Miles": "<=10 AND LENGTH >=20",
            "20 - 30 Miles": ">=20 AND LENGTH <=30",
            "30 - 40 Miles": ">=30 AND LENGTH <=40",
            "Greater than 40 Miles": ">=40"
        }
    },
    condition: 
    {
        name: "CONDITION",
        values: {
            "Excellent": "Excellent",
            "Average": "Average",
            "Poor": "Poor",
            "Not Evaluated": "Not Evaluated"
        }
    },
    fee: {
        name: "FEE",
        values: {
            "No": "No",
            "Yes": "Yes"
        }
    },
    status: {
        name: "STATUS",
        values: {
            "Open": "Open",
            "Closed": "Closed",
            "Varies": "Varies"
        }
    },
    // status: {
    //     name: "STATUS",
    //     values: {
    //         "Existing": "Existing",
    //         "Planned": "Planned",
    //         "Potential": "Potential"
    //     }
    // },
    open: {
        name: "OPEN_CLOSED",
        values: {
            "Open": "Open",
            "Closed": "Closed",
            "Varies": "Varies"
        }
    },
    trailClass: {
        name: "TRAIL_CLASS",
        values: {
            "National": "National",
            "State": "State",
            "Regional": "Regional",
            "County": "County",
            "Community": "Community"
        }
    },
    roadClass: {
        name: "ROAD_CLASS",
        values: {
            "Trail": "Trail",
            "On-Road Facility": "On-Road Facility"
        }
    },
    configuration: {
        name: "CONFIGURATION",
        values: {
            "Loop": "Loop",
            "Wilderness / Outback": "OutBack",
            "Linear": "Linear",
            "Not assessed": "Not assessed"
        }
    },
    difficulty: {
        name: "DIFFICULTY",
        values: {
            "Easiest": "Easiest",
            "Easy": "Easy",
            "Moderate": "MoreDiff",
            "Difficult": "VeryDiff",
            'ExtmDiff': 'Extreme',
            "Not Assessed": "NA"
        }
    },
    // difficulty: {
    //     name: "DIFFICULTY",
    //     values: {
    //     "Easiest": "Easiest",
    //     "Easy": "Easy",
    //     "Moderate": "Moderate",
    //     "Difficult": "Difficult",
    //     "Extreme": "Extreme",
    //     "Not Assessed": "Not Assessed"
    //     }
    // },
    surface: {
        name: "SURFACE",
        values: {
        "Natural Surface": "Natural Surface",
        "Aggregate": "Aggregate",
        "Paved": "Paved",
        "Snow": "Snow",
        "Boardwalk": "Boardwalk",
        "Other": "Other",
        "Unknown": "Unknown"
        }
    },
    wheelchairFriendly: {
        name: "WHEELCHAIR_FRIENDLY",
        values: {
            "Variable": "Var",
            "Yes": "Yes",
            "No": "No",
            "Unknown": "Unknown"
        }
    },
    primaryUse: {
        name: "PRIMARY_USE",
        values: {
            "Allowed": "Motor",
            "Not Allowed": "NonMech"
        }
    },
    primaryType: {
        name: "PRIMARY_TYPE",
        values: {
            "Hike / Walk": "HikeWalk",
            "Mountain Bike": "MntnBike",
            "Hunting & Fishing": "HuntFishAccess",
            "Horseback": "Equestrian",
            "Multi-use": "Multi-use",
            "Cross-country Ski Trail": "Cross-country Ski Trail",
            "Motorized Trail": "Motorized Trail",
            "Snowmobiling Trail": "Snowmobile"
        }
    },
    pedestrians: {
        name: "PEDESTRIANS",
        values: {
            "Recommended": "Recmnd",
            "Not Recommended": "NotRcmnd",
            "Unknown": "Unknown",
            "Not Allowed": "NotAllow"
        }
    },
    bicycles: {
        name: "BIKES",
        values: {
            "Recommended": "Recmnd",
            "Not Recommended": "NotRcmnd",
            "Unknown": "Unknown",
            "Not Allowed": "NotAllow"
        }
    },
    ebikes: {
        name: "E_BIKES",
        values: {
            "Recommended": "Recmnd",
            "Not Recommended": "NotRcmnd",
            "Unknown": "Unknown",
            "Not Allowed": "NotAllow",
        }
    },
    apvLess50: {
        name: "APV_50",
        values: {
            "Recommended": "Recmnd",
            "Not Recommended": "NotRcmnd",
            "Unknown": "Unknown",
            "Not Allowed": "NotAllow"
        }
    },
    apv50to62: {
        name: "APV_50_62",
        values: {
            "Recommended": "Recmnd",
            "Not Recommended": "NotRcmnd",
            "Unknown": "Unknown",
            "Not Allowed": "NotAllow"
        }
    },
    apvGreater62: {
        name: "APV_62",
        values: {
            "Recommended": "Recmnd",
            "Not Recommended": "NotRcmnd",
            "Unknown": "Unknown",
            "Not Allowed": "NotAllow"
        }
    },
    offroad: {
        name: "OFF_ROAD_4X4",
        values: {
            "Recommended": "Recmnd",
            "Not Recommended": "NotRcmnd",
            "Unknown": "Unknown",
            "Not Allowed": "NotAllow"
        }
    },
    snowmobiles: {
        name: "SNOWMOBILES",
        values: {
            "Recommended": "Recmnd",
            "Not Recommended": "NotRcmnd",
            "Unknown": "Unknown",
            "Not Allowed": "NotAllow"
        }
    },
    crossCountrySkiing: {
        name: "XC_SKIING",
        values: {
            "Recommended": "Recmnd",
            "Not Recommended": "NotRcmnd",
            "Unknown": "Unknown",
            "Not Allowed": "NotAllow"
        }
    },
    dogs: {
        name: "DOGS",
        values: {
            "Recommended": "Recmnd",
            "Not Recommended": "NotRcmnd",
            "Unknown": "Unknown",
            "Not Allowed": "NotAllow"
        }
    },
};
